(function(){
  /* ===== CONSTANTES EDITABLES ===== */
  var COMPANY_ID = 'QPR54y';                          // public API key (site ID) de Klaviyo · cuenta NDF
  var CTA_URL    = 'https://wa.me/56933353225?text=hola%2C%20quiero%20conocer%20ndf%20growth'; // link del botón "quiero conocer ndf growth"
  var SHOW_VIDEO = false;                             // bloque de video en el resultado
  var VIDEO_URL  = '';                                // .mp4 del video
  /* ================================ */
  var METRIC = 'Growth checklist quiz completado';
  var MAX = 14;
  var PET = '#022332';

  var QUESTIONS = [
    {axis:'marketing y decisiones', q:'si hay que tomar una decisión importante sobre campañas o inversión en marketing, ¿puede avanzar sin ti?',
     o:['sí, el equipo tiene criterios claros.','algunas decisiones sí, otras necesitan mi aprobación.','casi todas terminan pasando por mí.']},
    {axis:'capacidad para absorber crecimiento', q:'si mañana tus ventas aumentaran un 30%, ¿tu operación podría absorber ese crecimiento sin que tú tengas que intervenir mucho más?',
     o:['sí, tenemos estructura para hacerlo.','probablemente, aunque aparecerían algunos problemas.','no. seguramente aumentaría muchísimo mi carga.']},
    {axis:'stock e inventario', q:'cuando hay que decidir cuánto stock comprar o cómo reaccionar frente a un problema de inventario, ¿quién termina tomando la decisión?',
     o:['el equipo puede resolverlo con criterios definidos.','depende del caso.','generalmente yo.']},
    {axis:'equipo y autonomía', q:'¿tu equipo puede resolver problemas importantes sin preguntarte constantemente qué hacer?',
     o:['sí, existen responsables y criterios claros.','en algunas áreas sí.','no. muchas decisiones terminan escalando hacia mí.']},
    {axis:'qué pasa si tú no estás', q:'si te desconectaras completamente del negocio durante una semana, ¿qué crees que ocurriría?',
     o:['el negocio seguiría funcionando prácticamente igual.','funcionaría, pero algunas decisiones quedarían pendientes.','se acumularían problemas o decisiones importantes.']},
    {axis:'concentración de decisiones', q:'¿cuántas decisiones importantes de distintas áreas siguen dependiendo directamente de ti?',
     o:['muy pocas.','varias.','demasiadas: marketing, equipo, stock, proveedores, finanzas, etc.']},
    {axis:'claridad de prioridades', q:'cuando tienes varios problemas abiertos al mismo tiempo, ¿está claro cuáles son las 3–5 cosas que realmente deberías priorizar?',
     o:['sí, tenemos claridad sobre las prioridades.','a veces.','no. hay tantos frentes abiertos que cuesta saber qué atacar primero.']}
  ];
  var LETTERS = ['a','b','c'];

  var RESULTS = {
    rojo:{color:'#e7392f', ink:'#fff', label:'alta dependencia',
      title:'tu ecommerce depende demasiado de ti.',
      p:['tus respuestas muestran que muchas decisiones importantes todavía están concentradas en el founder.',
         'el problema es que, cuando el negocio crece, también pueden crecer las decisiones, excepciones y problemas que terminan llegando hasta ti.',
         'antes de intentar resolver diez cosas a la vez, necesitas identificar cuáles son las 3–5 palancas que realmente están frenando la evolución de tu empresa.']},
    amarillo:{color:'#E8B62C', ink:PET, label:'dependencia intermedia',
      title:'tu ecommerce todavía depende de ti en puntos importantes.',
      p:['ya existe cierta estructura, pero varias decisiones relevantes siguen regresando a ti.',
         'esto puede no parecer grave hoy, pero cuando el negocio crece también aumentan los pedidos, personas, stock, inversión y decisiones.',
         'el desafío está en identificar cuáles son las pocas palancas que necesitas destrabar para que el crecimiento no aumente también tu carga.']},
    verde:{color:'#7ED957', ink:PET, label:'baja dependencia',
      title:'tu ecommerce muestra una baja dependencia de ti.',
      p:['tus respuestas indican que existen criterios, responsables y cierta estructura que permiten que varias decisiones avancen sin necesitar constantemente tu intervención.',
         'eso no significa que no existan áreas por mejorar, pero la dependencia del founder no parece ser hoy el principal cuello de botella.']}
  };

  var state = {screen:'hero', idx:0, answers:[null,null,null,null,null,null,null], sel:null, name:'', email:'', sent:false, nav:false};
  var pollTimer = null;

  function root(){ return document.getElementById('ndf-gc'); }
  function esc(s){ return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function score(){ return state.answers.reduce(function(s,a){ return s+(a==null?0:a); },0); }
  function tramo(s){ return s>=10 ? 'rojo' : (s>=5 ? 'amarillo' : 'verde'); }
  function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim()); }

  function setBtnState(btn, enabled){
    if(!btn) return;
    btn.disabled = !enabled;
    btn.style.opacity = enabled ? '1' : '.35';
    btn.style.cursor = enabled ? 'pointer' : 'not-allowed';
    btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
  }

  /* ---------- pantallas ---------- */
  function renderHero(){
    var steps = [
      ['01','#7ED957','respondes 7 preguntas sobre cómo se toman hoy las decisiones en tu negocio.'],
      ['02','#E8762C','te mostramos qué tan dependiente de ti está tu ecommerce.'],
      ['03','#4884a3','te decimos cuál es tu siguiente paso para crecer sin cargar más decisiones.']
    ].map(function(s){ return '<div><b style="color:'+s[1]+'">'+s[0]+'</b><p>'+s[2]+'</p></div>'; }).join('');
    return '<section class="scr pet" style="min-height:100vh;min-height:100svh;padding-top:72px;padding-bottom:88px;display:flex;align-items:center">'+
      '<div class="wrap in" style="max-width:820px;gap:56px">'+
        '<div style="display:flex;flex-direction:column;gap:28px">'+
          '<p class="lbl">growth checklist ndf</p>'+
          '<h1 class="h1" tabindex="-1" data-focus>¿cuánto depende tu ecommerce de ti?</h1>'+
          '<p class="sub">tu ecommerce puede estar creciendo y, al mismo tiempo, seguir dependiendo demasiado de ti. responde estas 7 preguntas y descubre qué tan preparada está hoy tu empresa para crecer sin que cada decisión importante tenga que pasar por ti.</p>'+
          '<div style="display:flex;flex-direction:column;align-items:flex-start;gap:14px;margin-top:8px">'+
            '<button type="button" class="btn btn-crm btn-m-full" data-action="start">empezar el test</button>'+
            '<p class="micro">7 preguntas · 2 minutos</p>'+
          '</div>'+
        '</div>'+
        '<div style="height:1px;background:rgba(251,248,243,.14)"></div>'+
        '<div style="display:flex;flex-direction:column;gap:28px">'+
          '<p class="lbl">cómo funciona</p>'+
          '<div class="steps">'+steps+'</div>'+
        '</div>'+
      '</div>'+
    '</section>';
  }

  function renderAviso(){
    return '<section class="scr pet center" style="padding-top:72px;padding-bottom:72px">'+
      '<div class="wrap in" style="max-width:560px;gap:32px">'+
        '<p class="lbl">antes de empezar</p>'+
        '<p tabindex="-1" data-focus style="font-size:clamp(24px,5vw,30px);font-weight:600;line-height:1.28;letter-spacing:-.02em;text-wrap:pretty">responde pensando en cómo funciona tu negocio hoy, no en cómo te gustaría que funcionara.</p>'+
        '<div><button type="button" class="btn btn-crm btn-m-full" data-action="begin">entendido, vamos</button></div>'+
      '</div>'+
    '</section>';
  }

  function renderQuestion(){
    var i = state.idx, Q = QUESTIONS[i], sel = state.sel;
    var opts = Q.o.map(function(t,k){
      var on = sel===k;
      return '<button type="button" role="radio" class="opt" data-action="select" data-value="'+k+'" aria-checked="'+on+'" tabindex="'+((on||(sel==null&&k===0))?'0':'-1')+'">'+
        '<span class="l" aria-hidden="true">'+LETTERS[k]+'</span><span>'+esc(t)+'</span></button>';
    }).join('');
    return '<section class="scr crm" style="min-height:100vh;min-height:100svh;padding-top:40px;padding-bottom:72px">'+
      '<div class="wrap in" style="max-width:720px;gap:40px">'+
        '<div style="display:flex;flex-direction:column;gap:14px">'+
          '<div style="display:flex;justify-content:space-between;align-items:baseline;gap:16px;flex-wrap:wrap">'+
            '<p class="lbl">pregunta '+(i+1)+' de 7</p>'+
            '<p class="lbl" style="color:#022332;text-align:right">'+esc(Q.axis)+'</p>'+
          '</div>'+
          '<div class="bar" role="progressbar" aria-label="progreso" aria-valuemin="0" aria-valuemax="7" aria-valuenow="'+(i+1)+'"><i style="width:'+((i+1)/7*100)+'%"></i></div>'+
        '</div>'+
        '<h2 class="qh" id="gc-qt" tabindex="-1" data-focus>'+esc(Q.q)+'</h2>'+
        '<div class="opts" role="radiogroup" aria-labelledby="gc-qt">'+opts+'</div>'+
        '<div style="display:flex;align-items:center;gap:20px;flex-wrap:wrap">'+
          '<button type="button" class="btn btn-pet" data-action="next" id="gc-next">siguiente</button>'+
          (i>0 ? '<button type="button" class="lnk" data-action="prev">volver</button>' : '')+
        '</div>'+
      '</div>'+
    '</section>';
  }

  function renderGate(){
    return '<section class="scr crm center" style="padding-top:56px;padding-bottom:72px">'+
      '<div class="wrap in" style="max-width:520px;gap:28px">'+
        '<div style="display:flex;flex-direction:column;gap:16px">'+
          '<p class="lbl">último paso</p>'+
          '<h2 class="gh" tabindex="-1" data-focus>tu diagnóstico está listo.</h2>'+
          '<p class="ptxt">te mostraremos el diagnóstico en pantalla y también te llegará a tu correo.</p>'+
        '</div>'+
        '<form data-gc-form novalidate style="display:flex;flex-direction:column;gap:12px">'+
          '<label class="gc-sr" for="gc-name" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">tu nombre</label>'+
          '<input class="inp" id="gc-name" name="first_name" type="text" autocomplete="given-name" placeholder="tu nombre" value="'+esc(state.name)+'">'+
          '<label for="gc-email" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">tu correo</label>'+
          '<input class="inp" id="gc-email" name="email" type="email" inputmode="email" autocomplete="email" placeholder="tu correo" value="'+esc(state.email)+'">'+
          '<button type="submit" class="btn btn-pet btn-full" data-action="unlock" id="gc-unlock" style="margin-top:6px">ver mi diagnóstico</button>'+
        '</form>'+
        '<p class="micro">nada de spam. te escribimos cuando tenemos algo que sirve.</p>'+
      '</div>'+
    '</section>';
  }

  function renderResult(){
    var s = score(), t = tramo(s), R = RESULTS[t];
    var pct = Math.min(96, Math.max(4, ((MAX - s) + 0.5) / 15 * 100));
    var pin = '<svg class="pin" style="left:'+pct+'%" viewBox="0 0 24 24" aria-hidden="true">'+
      '<path d="M12 1.5c-4.4 0-8 3.5-8 7.9 0 5.6 6.9 12.4 7.2 12.7.4.4 1.1.4 1.5 0 .3-.3 7.3-7.1 7.3-12.7 0-4.4-3.6-7.9-8-7.9z" fill="'+PET+'"/>'+
      '<circle cx="12" cy="9.4" r="3.2" fill="#FBF8F3"/></svg>';
    var video = SHOW_VIDEO ?
      '<div style="display:flex;flex-direction:column;gap:14px"><p class="lbl">un minuto antes de tu diagnóstico</p>'+
        '<div class="video" data-gc-video>'+
          '<button type="button" class="play" data-action="play" aria-label="reproducir video">'+
            '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="'+PET+'"/></svg></button>'+
        '</div></div>' : '';
    var paras = R.p.map(function(p,k){ return '<p class="'+(k===0?'pmain':'psec')+'">'+esc(p)+'</p>'; }).join('');
    return '<section class="scr crm" style="padding-top:48px;padding-bottom:96px">'+
      '<div class="wrap in" style="max-width:820px;gap:44px">'+
        '<div style="display:flex;flex-direction:column;gap:20px">'+
          '<span class="pill" style="background:'+R.color+';color:'+R.ink+'">'+esc(R.label)+'</span>'+
          '<h1 class="rh" tabindex="-1" data-focus>'+esc(R.title)+'</h1>'+
        '</div>'+
        '<div class="meter" role="img" aria-label="medidor: '+esc(R.label)+'">'+pin+
          '<div class="track"><span style="background:#e7392f"></span><span style="background:#E8B62C"></span><span style="background:#7ED957"></span></div>'+
          '<div class="mlbl" aria-hidden="true"><span>alta dependencia</span><span style="text-align:center">dependencia intermedia</span><span style="text-align:right">baja dependencia</span></div>'+
        '</div>'+
        video+
        '<div style="border-top:1px solid rgba(2,35,50,.12);padding-top:36px;display:flex;flex-direction:column;gap:20px">'+
          '<p class="lbl">tu diagnóstico</p>'+paras+
        '</div>'+
        '<div class="cta">'+
          '<h3>¿quieres descubrir cuáles podrían ser las próximas palancas de tu ecommerce?</h3>'+
          '<p>en ndf growth trabajamos durante 60 días para identificar y trabajar sobre 3–5 palancas clave que están condicionando el crecimiento de tu ecommerce y su dependencia de ti.</p>'+
          '<div><a class="btn btn-crm btn-m-full" href="'+esc(CTA_URL)+'" data-action="cta">quiero conocer ndf growth</a></div>'+
        '</div>'+
        '<div><button type="button" class="lnk" data-action="restart">volver a empezar</button></div>'+
      '</div>'+
    '</section>';
  }

  var RENDER = {hero:renderHero, aviso:renderAviso, question:renderQuestion, gate:renderGate, result:renderResult};

  function render(){
    var el = root(); if(!el) return;
    stopPolling();
    el.innerHTML = RENDER[state.screen]();
    if(state.screen==='question') setBtnState(el.querySelector('#gc-next'), state.sel!=null);
    if(state.screen==='gate'){ syncGate(); startPolling(); }
    if(state.nav){
      var f = el.querySelector('[data-focus]');
      if(f){ try{ f.focus({preventScroll:true}); }catch(e){ f.focus(); } }
      var top = el.getBoundingClientRect().top;
      if(Math.abs(top) > 4){ try{ el.scrollIntoView({behavior:'smooth', block:'start'}); }catch(e){ el.scrollIntoView(); } }
    }
  }

  /* ---------- gate ---------- */
  function syncGate(){
    var el = root(); if(!el) return false;
    var n = el.querySelector('#gc-name'), m = el.querySelector('#gc-email');
    if(n) state.name = n.value;
    if(m) state.email = m.value;
    var ok = state.name.trim().length>0 && validEmail(state.email);
    setBtnState(el.querySelector('#gc-unlock'), ok);
    return ok;
  }
  function startPolling(){ pollTimer = setInterval(function(){ if(state.screen==='gate') syncGate(); else stopPolling(); }, 350); }
  function stopPolling(){ if(pollTimer){ clearInterval(pollTimer); pollTimer = null; } }

  /* ---------- klaviyo ---------- */
  function sendKlaviyo(){
    if(state.sent) return;
    state.sent = true;
    if(!COMPANY_ID || COMPANY_ID==='XXXXXX'){ console.warn('[growth checklist] COMPANY_ID de Klaviyo no configurado'); return; }
    var s = score(), t = tramo(s), R = RESULTS[t], resp = {};
    state.answers.forEach(function(a,i){ resp['p'+(i+1)] = LETTERS[a]; });
    var body = {data:{type:'event',attributes:{
      properties:{
        puntaje:s, puntaje_max:MAX, tramo:t,
        resultado_label:R.label, resultado_titulo:R.title,
        resultado_p1:R.p[0]||'', resultado_p2:R.p[1]||'', resultado_p3:R.p[2]||'',
        respuestas:resp
      },
      metric:{data:{type:'metric',attributes:{name:METRIC}}},
      profile:{data:{type:'profile',attributes:{email:state.email.trim(), first_name:state.name.trim()}}}
    }}};
    fetch('https://a.klaviyo.com/client/events?company_id='+encodeURIComponent(COMPANY_ID), {
      method:'POST', keepalive:true,
      headers:{'Content-Type':'application/vnd.api+json','revision':'2024-10-15'},
      body:JSON.stringify(body)
    }).catch(function(e){ console.warn('[growth checklist] error al enviar a klaviyo', e); });
  }

  /* ---------- acciones ---------- */
  function go(screen){ state.screen = screen; state.nav = true; render(); }
  function openQuestion(i){ state.idx = i; state.sel = state.answers[i]; go('question'); }
  function select(k){
    state.sel = k;
    var el = root();
    el.querySelectorAll('#ndf-gc .opt').forEach(function(o){
      var on = parseInt(o.getAttribute('data-value'),10)===k;
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      o.tabIndex = on ? 0 : -1;
    });
    setBtnState(el.querySelector('#gc-next'), true);
  }
  function unlock(){
    if(!syncGate()) return;
    go('result');
    sendKlaviyo();
  }
  var actions = {
    start:function(){ go('aviso'); },
    begin:function(){ openQuestion(0); },
    select:function(btn){ select(parseInt(btn.getAttribute('data-value'),10)); },
    next:function(){
      if(state.sel==null) return;
      state.answers[state.idx] = state.sel;
      if(state.idx < QUESTIONS.length-1) openQuestion(state.idx+1); else go('gate');
    },
    prev:function(){ if(state.idx>0) openQuestion(state.idx-1); },
    unlock:unlock,
    play:function(){
      var box = root().querySelector('[data-gc-video]');
      if(box && VIDEO_URL){ box.innerHTML = '<video src="'+esc(VIDEO_URL)+'" playsinline controls autoplay></video>'; }
    },
    restart:function(){
      state.idx = 0; state.answers = [null,null,null,null,null,null,null]; state.sel = null; state.sent = false;
      go('hero');
    }
  };

  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('#ndf-gc [data-action]') : null;
    if(!btn) return;
    var a = btn.getAttribute('data-action');
    if(a==='cta') return;
    e.preventDefault();
    if(btn.disabled) return;
    if(actions[a]) actions[a](btn);
  });
  document.addEventListener('submit', function(e){
    if(!e.target.closest || !e.target.closest('#ndf-gc')) return;
    e.preventDefault(); unlock();
  });
  ['input','change'].forEach(function(ev){
    document.addEventListener(ev, function(e){
      if(state.screen==='gate' && e.target.closest && e.target.closest('#ndf-gc')) syncGate();
    });
  });
  document.addEventListener('keydown', function(e){
    var opt = e.target.closest ? e.target.closest('#ndf-gc .opt') : null;
    if(!opt) return;
    var list = Array.prototype.slice.call(root().querySelectorAll('.opt')), i = list.indexOf(opt), n = null;
    if(e.key==='ArrowDown'||e.key==='ArrowRight') n = list[(i+1)%list.length];
    else if(e.key==='ArrowUp'||e.key==='ArrowLeft') n = list[(i-1+list.length)%list.length];
    if(n){ e.preventDefault(); select(parseInt(n.getAttribute('data-value'),10)); n.focus(); }
  });

  function boot(){ var el = root(); if(el && !el.firstChild) render(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  new MutationObserver(function(){ var el = root(); if(el && !el.firstChild) render(); }).observe(document.body, {childList:true, subtree:true});
})();